import { ContentCardProps } from 'app/components/content/ContentCard'
import { Pagination } from 'app/types/pagination'
import { gql } from 'graphql-request'

import { defaultsQuery } from '../globals/defaults'

export const contentFragments = gql`
  fragment content on Content {
    id
    title
    slug

    thumbnail {
      id
      url
      sizes {
        thumbnail {
          url
        }
        thumbnail2x {
          url
        }
      }
    }
    commentCount
    disableComments
    createdAt
    publishedAt
    videoLength
    videoPost
    primaryCollection {
      name
      slug
      backgroundColour
      foregroundColour
      episodeOverlay {
        id
        url
        sizes {
          thumbnail {
            url
          }
          thumbnail2x {
            url
          }
        }
      }
    }
    disableSeriesOverlay

    contentTier {
      planLevel
    }
  }
`

export const createContentListQuery = () => gql`
  ${contentFragments}
  query getAllContent($limit: Int!, $page: Int!) {
    Contents(sort: "-publishedAt", limit: $limit, page: $page) {
      totalDocs
      page
      docs {
        ...content
      }
    }

    ${defaultsQuery}
  }
`

export const createContentSlugsOnlyQuery = () => gql`
  query getAllContent($limit: Int!, $page: Int!) {
    Contents(sort: "-publishedAt", limit: $limit, page: $page) {
      totalDocs
      page
      docs {
        slug
        updatedAt
      }
    }
  }
`

export const mapToContentCard = (
  data: any,
  defaults: any,
): ContentCardProps => {
  const seriesOverlay = data.primaryCollection?.episodeOverlay
  const shouldApplyOverlay =
    !data.disableSeriesOverlay && seriesOverlay?.sizes?.thumbnail?.url

  return {
    id: data.id,
    image:
      data.thumbnail?.sizes?.thumbnail?.url ||
      data.thumbnail?.url ||
      defaults?.thumbnail?.sizes?.thumbnail?.url,
    image2x:
      data.thumbnail?.sizes?.thumbnail2x?.url ||
      data.thumbnail?.url ||
      defaults?.thumbnail?.sizes?.thumbnail2x?.url,
    contentTier: data.contentTier?.planLevel || 1,
    title: data.title,
    href: `/content/${data.slug}`,
    slug: data.slug,
    categoryHref: `/collection/${data.primaryCollection?.slug}`,
    commentCount: data.commentCount,
    datePublished: new Date(
      data.publishedAt || data.createdAt,
    ).toLocaleDateString(),
    category: data.primaryCollection?.name || '',
    duration: data.videoLength || '',
    videoPost: data.videoPost || false,
    disableComments: data?.disableComments || false,
    backgroundColour: data.primaryCollection?.backgroundColour || null,
    foregroundColour: data.primaryCollection?.foregroundColour || null,
    seriesOverlayUrl: shouldApplyOverlay
      ? seriesOverlay?.sizes?.thumbnail?.url
      : null,
  }
}

export const contentListQueryToContentList = (
  data: any,
): Pagination<ContentCardProps> => {
  const res = data.Contents || data.search

  const docs = res.docs.map((item: any) =>
    mapToContentCard(item, data.Defaults),
  )

  return {
    total: res.totalDocs,
    page: res.page,
    docs,
  }
}

export const contentSlugsOnlyQueryToContentList = (
  data: any,
): Pagination<{ slug: string; updatedAt: string }> => {
  const res = data.Contents || data.search

  const docs = res.docs.map((item: any) => ({
    slug: item.slug,
    updatedAt: item.updatedAt,
  }))

  return {
    total: res.totalDocs,
    page: res.page,
    docs,
  }
}
